import React from "react";
import { MetaPixel } from "./components/MetaPixel";
import { FloatingCta } from "./components/FloatingCta";
import { PurchasePopup } from "./components/PurchasePopup";
import { Hero } from "./components/sections/Hero";
import { SystemIntro } from "./components/sections/SystemIntro";
import { BeforeAfter } from "./components/sections/BeforeAfter";
import { PainPoints } from "./components/sections/PainPoints";
import { Volumes } from "./components/sections/Volumes";
import { Extras } from "./components/sections/Extras";
import { Bonuses } from "./components/sections/Bonuses";
import { Offer } from "./components/sections/Offer";
import { Guarantee } from "./components/sections/Guarantee";
import { Testimonials } from "./components/sections/Testimonials";
import { Creator } from "./components/sections/Creator";
import { Faq } from "./components/sections/Faq";
import { FinalCta } from "./components/sections/FinalCta";
import { Footer } from "./components/sections/Footer";
export function App() {
  return <div className="w-full overflow-x-hidden bg-cream font-sans text-ink antialiased" data-id="element-0" data-mp="3iiwasc8k4vxf">
      <MetaPixel data-id="element-1" data-mp="3mkrgdsxitvh0" />
      <Hero data-id="element-2" data-mp="3mk83iqmq9x9u" />
      <main data-id="element-3" data-mp="3mjq2lgp4euvl">
        <SystemIntro data-id="element-4" data-mp="3mjgczu7zmpqf" />
        <BeforeAfter data-id="element-5" data-mp="3rcj6y3gog175" />
        <PainPoints data-id="element-6" data-mp="3rbznujfaj6rj" />
        <Volumes data-id="element-7" data-mp="3rdkkqfp2v1sk" />
        <Extras data-id="element-8" data-mp="3rd17vdeab3le" />
        <Bonuses data-id="element-9" data-mp="3relwynhtxubv" />
        <Offer data-id="element-10" data-mp="5opiv1o0k3w" />
        <Guarantee data-id="element-11" data-mp="6801qozk67w" />
        <Testimonials data-id="element-12" data-mp="4n7g6m8exco" />
        <Creator data-id="element-13" data-mp="82kl3wchwbg" />
        <Faq data-id="element-14" data-mp="2zl3azit8d249" />
        <FinalCta data-id="element-15" data-mp="2zld43f9knpe6" />
      </main>
      <Footer data-id="element-16" data-mp="2zmeowbge3q93" />
      <FloatingCta anchorId="first-cta" data-id="element-17" data-mp="2zmo89g6xiz5t" />
      <PurchasePopup data-id="element-18" data-mp="33mf25srr5vek" />
    </div>;
}